import React, { useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';

import { OnlyContinueButton } from 'components/base/BottomStepComponent';
import { APIStatus, CampaignType, EarningRuleRewardType } from 'config/CustomEnums';
import BaseCreationStepContentByConfig from 'components/base/BaseCreationStepContentByConfig';
import { CREATE_CAMPAIGN_TYPE_PAGE_CONFIG } from 'containers/engagement/campaignStreamline/CreateCampaignTypePageConfig';

import './CreateCampaignTypePage.scss';
import { scrollToAnchor } from './CreateCampaignHandleError';
import { getStepWithCoupon } from 'models/CampaignStreamlineModel';
import Loading from 'components/base/Loading';

const CreateCampaignTypePage = ({
  anchorKey,
  sectionKey,
  detailLoading,
}) => {
  const dispatch = useDispatch();
  const {
    watch,
  } = useFormContext();

  const campaignTypeField = 'campaignType';
  const earningRuleRewardTypeField = 'linkedEarningRules.rewardType';
  const earningRuleTypeField = 'linkedEarningRules.type';
  const haveCreatedCouponField = 'haveCreatedCoupon';
  const linkedCouponField = 'linkedCoupon';

  const watchCampaignType = watch(campaignTypeField);
  const earningRuleRewardType = watch(earningRuleRewardTypeField);
  const watchEarningRuleType = watch(earningRuleTypeField);
  const watchHaveCreatedCoupon = watch(haveCreatedCouponField);
  const watchLinkedCoupon = watch(linkedCouponField);

  const goToNextStep = () => {
    dispatch({
      type: 'campaignStreamline/stepChange',
      payload: { step: 1 },
    });
  };

  useEffect(() => {
    dispatch({
      type: 'campaignStreamline/updateSteps',
      payload: {
        stepWithCoupon: getStepWithCoupon({
          campaignType: watchCampaignType,
          earningRuleRewardType,
          haveCreatedCoupon: watchHaveCreatedCoupon,
        }),
      }
    })
  }, [
    dispatch,
    watchCampaignType,
    earningRuleRewardType,
    watchHaveCreatedCoupon,
    detailLoading,
  ])

  useEffect(() => {
    console.log("@@createCampaignTypePage", anchorKey, sectionKey);
    scrollToAnchor(anchorKey, sectionKey, -100);
  }, [anchorKey, sectionKey]);

  const disabledContinueButton = useMemo(() => {
    if (!watchCampaignType) {
      return true
    }
    if (watchCampaignType === CampaignType.earningRulesCampaign) {
      if (!earningRuleRewardType || !watchEarningRuleType) {
        return true
      }
      if (earningRuleRewardType === EarningRuleRewardType.coupons && watchHaveCreatedCoupon === undefined) {
        return true
      }
      if (earningRuleRewardType === EarningRuleRewardType.coupons && watchHaveCreatedCoupon && !watchLinkedCoupon?.pk) {
        return true
      }
    }
    if (watchCampaignType === CampaignType.couponsCampaign) {
      if (watchHaveCreatedCoupon === undefined) {
        return true
      }
      if (watchHaveCreatedCoupon && !watchLinkedCoupon?.pk) {
        return true
      }
    }
    return false
  }, [
    watchCampaignType,
    earningRuleRewardType,
    watchEarningRuleType,
    watchHaveCreatedCoupon,
    watchLinkedCoupon,
  ])

  if (detailLoading === APIStatus.calling) {
    return <Loading />
  };

  return (
    <>
      <BaseCreationStepContentByConfig
        configuration={CREATE_CAMPAIGN_TYPE_PAGE_CONFIG}
        hidePreview
      />
      <OnlyContinueButton
        continueAction={goToNextStep}
        disabledContinue={disabledContinueButton}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  anchorKey: state.campaignStreamline.anchorKey,
  sectionKey: state.campaignStreamline.sectionKey,
  detailLoading: state.createCampaign.detailLoading,
});

export default connect(mapStateToProps)(CreateCampaignTypePage);
